import {Pagination, Table, Tag, Tooltip, notification} from "antd";
import {renderDateTime} from "../../../../utils";
import {Button, Icon} from "../../../../components";

const statusConfig = {
    0: {color: 'orange', label: 'Chờ duyệt'},
    1: {color: 'green',  label: 'Đã duyệt'},
    2: {color: 'red',    label: 'Từ chối'},
};

function BuilderLicenseTable({items = [], pagination, onPaginationChange, can, onDelete, onViewDetail})
{
    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 70,
            render: (_, item) => (
                <span
                    style={{color: '#1677ff', cursor: 'pointer'}}
                    onClick={() => onViewDetail(item)}
                >
                    #{item.id}
                </span>
            )
        },
        {
            title: "Tên Website",
            dataIndex: "websiteName",
            key: "websiteName",
            render: (_, item) => (
                <div>
                    <div><strong>{item.websiteName}</strong></div>
                    <small className="text-muted">{item.websiteUrl}</small>
                </div>
            )
        },
        {
            title: "Elements",
            dataIndex: "elements",
            key: "elements",
            width: 120,
            render: (_, item) => {
                const list = item.elements
                    ? (typeof item.elements === 'string' ? JSON.parse(item.elements) : item.elements)
                    : [];
                return list.length > 0
                    ? <Tag color="blue">{list.length} elements</Tag>
                    : <span className="text-muted">—</span>;
            }
        },
        {
            title: "License Key",
            dataIndex: "license",
            key: "license",
            width: 260,
            render: (_, item) => {
                if (!item.license) return <span className="text-muted">Chưa có</span>;
                return (
                    <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                        <code style={{fontSize: 11, flex: 1, wordBreak: 'break-all'}}>{item.license}</code>
                        <Tooltip title="Copy">
                            <Button
                                small
                                background
                                onClick={() => {
                                    navigator.clipboard.writeText(item.license);
                                    notification.success({message: 'Đã copy', duration: 1});
                                }}
                                leftIcon={Icon.copy}
                            ></Button>
                        </Tooltip>
                    </div>
                );
            }
        },
        {
            title: "Hạn sử dụng",
            dataIndex: "expired",
            key: "expired",
            width: 150,
            render: (_, item) => item.expired
                ? renderDateTime(item.expired)
                : <span className="text-muted">Vĩnh viễn</span>
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            width: 120,
            render: (_, item) => {
                const cfg = statusConfig[item.status] ?? statusConfig[0];
                return <Tag color={cfg.color}>{cfg.label}</Tag>;
            }
        },
        {
            title: "Người tạo",
            dataIndex: "userId",
            key: "userId",
            width: 160,
            render: (_, item) => item.user
                ? `${item.user.firstname} ${item.user.lastname}`
                : ''
        },
        {
            title: "Ngày tạo",
            dataIndex: "created",
            key: "created",
            width: 150,
            render: (_, item) => renderDateTime(item.created)
        },
        {
            title: '#',
            dataIndex: 'action',
            key: "action",
            width: 120,
            render: (_, item) => (
                <div className="table-action d-flex">
                    <Tooltip title="Chi tiết">
                        <Button background blue leftIcon={Icon.info} onClick={() => onViewDetail(item)}></Button>
                    </Tooltip>
                    {can.delete && item.status !== 1 && (
                        <Tooltip title="Xóa">
                            <Button background red leftIcon={Icon.delete} onClick={() => onDelete(item.id)}></Button>
                        </Tooltip>
                    )}
                </div>
            )
        }
    ];

    const dataSource = items.map(row => ({key: row.id, ...row}));

    return (
        <div className="table-wrapper">
            <div className="table-box">
                <Table columns={columns} dataSource={dataSource} scroll={{y: 550}} pagination={false}/>
            </div>
            <Pagination
                current={pagination.page}
                defaultCurrent={1}
                defaultPageSize={20}
                pageSize={pagination.limit}
                total={pagination.totalRows}
                onChange={onPaginationChange}
                showSizeChanger={false}
            />
        </div>
    );
}

export default BuilderLicenseTable;
